"use strict";

var resolveException = require("../lib/resolve-exception")
  , is               = require("./is");

module.exports = function (value/*, options*/) {
	if (is(value)) return value;
	return resolveException(value, "%v is not a plain function", arguments[1]);
};



//////////////////
// WEBPACK FOOTER
// ./~/type/plain-function/ensure.js
// module id = 3335
// module chunks = 0